import { addTransition } from 'src/styles/theme/utils/functions';
import styled from 'styled-components';

export const StyledDotsNavigation = styled.div<{ isHidden?: boolean }>`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;

	height: 100%;

	${addTransition()}

	${(p) => (p.isHidden ? 'opacity: 0; pointer-events: none;' : '')}
`;

export const StyledHotkeyTooltipContainer = styled.div<{ paddingLeft: number }>`
	padding-left: ${({ paddingLeft }) => `${paddingLeft}px`};
`;
